export default {
  headerName: 'Nombre',
  headerClientId: 'ID de Cliente',
  headerDateCreated: 'Fecha de creación',
  headerRetries: 'Reintentos',
  headerActions: 'Acciones',
  chipAbandoned: 'abandonado',
  tooltipAbandonedRetries: 'Se abandonó después de {count} reintentos. No se volverá a reintentar; reinícialo cuando la causa esté resuelta.',
  // Indexado por el código que escribe reportSpawnFailure para un error que reintentar no puede resolver.
  abandonedReasons: {
    missing_boot_image: 'La familia de imagen de arranque que pide este modelo no existe en este proyecto, y ningún reintento puede resolverlo. Reinícialo cuando la familia de imagen esté creada o la configuración del modelo corregida.'
  },
  tooltipRestart: 'Reiniciar',
  tooltipDelete: 'Eliminar',
  dialogWarningTitle: 'Advertencia',
  dialogDeleteMessage: 'El documento de simulación ha sido eliminado por el usuario. ¿Desea eliminar el documento de la cola?',
  dialogDeleting: 'Eliminando:',
  dialogConfirmMessage: 'Esta acción no se puede deshacer. ¿Está seguro?',
  dialogCancel: 'Cancelar',
  dialogDelete: 'Eliminar',
  snackTryingRestart: 'Intentando reiniciar plan',
  snackPlanRestarted: 'Plan pendiente reiniciado',
  snackDeletingPlan: 'Eliminando plan',
  snackPlanDeleted: 'Plan eliminado'
}
